import React, { Fragment } from 'react';

import {
    ExcludeTimeButton,
    ExcludeTimeText,
    ExcludeTimeIcon,
    ExcludeTextX
} from './styles';

export const TimeExclude = ({ start, end, excludeHandler, disabled }) => {
    return (
        <Fragment>
            <ExcludeTimeButton type="button" disabled={disabled}>
                <ExcludeTimeText>
                    {start} - {end}
                </ExcludeTimeText>
                <ExcludeTimeIcon onClick={excludeHandler}>
                    <ExcludeTextX>✕</ExcludeTextX>
                </ExcludeTimeIcon>
            </ExcludeTimeButton>
        </Fragment>
    );
};
